export default response => ({
  page: parseInt(response.query.page, 10) || 1,
  pages: Math.ceil(response.total / response.query.size),
  pageSize: response.query.size,
  sort: response.query.sort,
  sortFieldType: response.query.sortFieldType,
  things: response.things.map(thing => thing.thingName),
  totalCount: response.total
});
